import { Component } from 'react';

import CustomerLoggedIn from './customer/CustomerLoggedIn';
import CustomerNotLoggedIn from './customer/CustomerNotLoggedIn';
import PaymentLoggedIn from './payment/PaymentLoggedIn';
import PaymentNotLoggedIn from './payment/PaymentNotLoggedIn';
import Process from './process/Process';

class EditStep extends Component {
  render() {
    const { step, onEdit, reservationCart, customer } = this.props;
    switch (step) {
      case 'customer':
        if (customer && reservationCart.customerId) {
          return (
            <CustomerLoggedIn
              reservationCart={reservationCart}
              onEdit={onEdit}
              onPickup={this.handlePickup}
            />
          );
        }
        return (
          <CustomerNotLoggedIn
            reservationCart={reservationCart}
            onEdit={onEdit}
            onPickup={this.handlePickup}
          />
        );
      case 'payment':
        if (customer && reservationCart.customerId) {
          return (
            <PaymentLoggedIn
              reservationCart={reservationCart}
              onEdit={onEdit}
            />
          );
        }
        return (
          <PaymentNotLoggedIn
            reservationCart={reservationCart}
            onEdit={onEdit}
          />
        );
      case 'complete':
        return <Process reservationCart={reservationCart} />;
      default:
        throw new Error('Invalid Step');
    }
  }
}

export default EditStep;
